var map = {
	"./calculator.svg": "7a6e",
	"./chrome.svg": "1f2a",
	"./command.svg": "b511",
	"./domains.svg": "8fb3",
	"./drop.svg": "e70f",
	"./droped.svg": "089a",
	"./dynamic.svg": "63a4",
	"./excel.svg": "b03d",
	"./firefox.svg": "fa51",
	"./hosts.svg": "b5c6",
	"./http.svg": "0ef5",
	"./https.svg": "630d",
	"./ie.svg": "0bcd",
	"./note.svg": "a9c9",
	"./other.svg": "6a5f",
	"./outlook.svg": "355d",
	"./pdf.svg": "d259",
	"./pointBoard.svg": "5fbdd",
	"./powershell.svg": "a78c",
	"./ppt.svg": "21b0",
	"./registry.svg": "75c5",
	"./resources.svg": "7673",
	"./script.svg": "034d",
	"./start.svg": "8ee7",
	"./startProgress.svg": "849f",
	"./system.svg": "add1",
	"./word.svg": "0d98",
	"./wps.svg": "ab5b",
	"./zip.svg": "ba9c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a018";